import { signOutUser, currentUser, isSchoolOwnerCached, isAdminCached, isTeacherCached } from '../lib/auth.js';
import { navigate } from '../router.js';
import { brandMarkHtml } from './brandMark.js';
import { PAYMENTS_ENABLED } from '../lib/featureFlags.js';

export function renderTopbar(activeRoute) {
  const user = currentUser();
  const initials = (user?.displayName || user?.email || '?').slice(0, 1).toUpperCase();
  // "School" / "Admin" show for accounts the server reports as school
  // owners / site administrators (per-uid flags refreshed on every sign-in
  // and app load — see lib/auth.js), so neither role ever needs to type a
  // URL by hand. Both routes stay server-guarded regardless — cosmetic.
  const isSchoolOwner = isSchoolOwnerCached();
  const isAdmin = isAdminCached();
  const isTeacher = isTeacherCached();
  const el = document.createElement('div');
  el.className = 'topbar';
  el.innerHTML = `
    <div class="brand" style="cursor:pointer" id="brand-home">${brandMarkHtml()} Simustage</div>
    <nav>
      <button class="btn btn-ghost" data-nav="/">Home</button>
      <button class="btn btn-ghost" data-nav="/marketplace">Library</button>
      ${isAdmin ? '<button class="btn btn-ghost" data-nav="/drive">🚗 Drive</button>' : ''}
      ${PAYMENTS_ENABLED ? '<button class="btn btn-ghost" data-nav="/wallet">Wallet</button>' : ''}
      ${isSchoolOwner
        ? '<button class="btn btn-ghost" data-nav="/school/scores">Scores</button>'
        : '<button class="btn btn-ghost" data-nav="/scores">My Scores</button>'}
      ${isTeacher ? '<button class="btn btn-ghost" data-nav="/teaching">Teaching</button>' : ''}
      ${isSchoolOwner ? '<button class="btn btn-ghost" data-nav="/school">School</button>' : ''}
      ${isAdmin ? '<button class="btn btn-ghost" data-nav="/dwar">Admin</button>' : ''}
      <button class="btn btn-ghost" data-nav="/settings">Settings</button>
    </nav>
    <div class="topbar-user">
      <span style="font-size:0.85rem;color:var(--text-dim);">${user?.displayName || user?.email || ''}</span>
      <div class="avatar">${initials}</div>
      <button class="btn btn-sm" id="signout-btn">Sign out</button>
    </div>
  `;
  el.querySelector('#brand-home').addEventListener('click', () => navigate('/'));
  el.querySelectorAll('[data-nav]').forEach((b) => b.addEventListener('click', () => navigate(b.dataset.nav)));
  el.querySelector('#signout-btn').addEventListener('click', async () => { await signOutUser(); navigate('/'); });
  return el;
}
